import { useState, useCallback } from "react";
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";
import { motion, AnimatePresence } from "framer-motion";
import { MapPin, ChevronDown } from "lucide-react";

const GEO_URL = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const ALL_POSITIONS = [
  // Alabama
  { city: "Opelika",               state: "AL", lat: 32.65,  lng: -85.38  },
  // Arizona
  { city: "Casa Grande",           state: "AZ", lat: 32.88,  lng: -111.76 },
  { city: "Mesa",                  state: "AZ", lat: 33.42,  lng: -111.84 },
  { city: "Phoenix",               state: "AZ", lat: 33.45,  lng: -112.07 },
  // California
  { city: "Fontana",               state: "CA", lat: 34.09,  lng: -117.43 },
  { city: "Montebello",            state: "CA", lat: 34.01,  lng: -118.11 },
  { city: "Ontario",               state: "CA", lat: 34.06,  lng: -117.65 },
  { city: "Rialto",                state: "CA", lat: 34.11,  lng: -117.37 },
  { city: "Sacramento",            state: "CA", lat: 38.58,  lng: -121.49 },
  { city: "Shafter",               state: "CA", lat: 35.50,  lng: -119.27 },
  { city: "Van Nuys",              state: "CA", lat: 34.19,  lng: -118.45 },
  { city: "Woodland",              state: "CA", lat: 38.68,  lng: -121.77 },
  // Colorado
  { city: "Denver",                state: "CO", lat: 39.74,  lng: -104.99 },
  { city: "Pueblo",                state: "CO", lat: 38.26,  lng: -104.61 },
  // Connecticut
  { city: "East Granby",           state: "CT", lat: 41.95,  lng: -72.74  },
  { city: "Hartford",              state: "CT", lat: 41.76,  lng: -72.68  },
  { city: "West Haven",            state: "CT", lat: 41.27,  lng: -72.95  },
  { city: "Windsor Locks",         state: "CT", lat: 41.93,  lng: -72.63  },
  // Delaware
  { city: "Millsboro",             state: "DE", lat: 38.59,  lng: -75.29  },
  { city: "Selbyville",            state: "DE", lat: 38.46,  lng: -75.22  },
  // Florida
  { city: "Arcadia",               state: "FL", lat: 27.22,  lng: -81.86  },
  // Georgia
  { city: "Adairsville",           state: "GA", lat: 34.37,  lng: -84.93  },
  { city: "Austell",               state: "GA", lat: 33.81,  lng: -84.64  },
  // Iowa
  { city: "Des Moines",            state: "IA", lat: 41.59,  lng: -93.62  },
  // Illinois
  { city: "Chicago",               state: "IL", lat: 41.88,  lng: -87.63  },
  { city: "Elk Grove Village",     state: "IL", lat: 42.00,  lng: -87.97  },
  { city: "Rock Island",           state: "IL", lat: 41.51,  lng: -90.57  },
  // Indiana
  { city: "Bluffton",              state: "IN", lat: 40.74,  lng: -85.17  },
  { city: "Fort Wayne",            state: "IN", lat: 41.08,  lng: -85.14  },
  { city: "Indianapolis",          state: "IN", lat: 39.77,  lng: -86.16  },
  { city: "Lafayette",             state: "IN", lat: 40.42,  lng: -86.88  },
  { city: "Shelbyville",           state: "IN", lat: 39.52,  lng: -85.78  },
  { city: "Valparaiso",            state: "IN", lat: 41.47,  lng: -87.06  },
  // Kansas
  { city: "Edwardsville",          state: "KS", lat: 39.06,  lng: -94.82  },
  { city: "Kansas City",           state: "KS", lat: 39.11,  lng: -94.63  },
  // Louisiana
  { city: "Lafayette",             state: "LA", lat: 30.22,  lng: -92.02  },
  // Massachusetts
  { city: "Ayer",                  state: "MA", lat: 42.56,  lng: -71.59  },
  { city: "Fall River",            state: "MA", lat: 41.70,  lng: -71.16  },
  { city: "North Hatfield",        state: "MA", lat: 42.39,  lng: -72.60  },
  { city: "Westfield",             state: "MA", lat: 42.12,  lng: -72.75  },
  // Maryland
  { city: "Perryville",            state: "MD", lat: 39.56,  lng: -76.07  },
  // Michigan
  { city: "Albion",                state: "MI", lat: 42.24,  lng: -84.75  },
  { city: "Grand Rapids",          state: "MI", lat: 42.96,  lng: -85.67  },
  { city: "Portage",               state: "MI", lat: 42.20,  lng: -85.58  },
  // Minnesota
  { city: "St. Paul",              state: "MN", lat: 44.95,  lng: -93.09  },
  { city: "Willmar",               state: "MN", lat: 45.12,  lng: -95.04  },
  // Missouri
  { city: "Blue Springs",          state: "MO", lat: 39.02,  lng: -94.28  },
  { city: "Harrisonville",         state: "MO", lat: 38.65,  lng: -94.35  },
  { city: "Kansas City",           state: "MO", lat: 39.10,  lng: -94.58  },
  { city: "O'Fallon",              state: "MO", lat: 38.81,  lng: -90.70  },
  { city: "St. Louis",             state: "MO", lat: 38.63,  lng: -90.20  },
  // Montana
  { city: "Butte",                 state: "MT", lat: 46.00,  lng: -112.54 },
  // North Carolina
  { city: "Charlotte",             state: "NC", lat: 35.23,  lng: -80.84  },
  { city: "Gastonia",              state: "NC", lat: 35.26,  lng: -81.19  },
  { city: "Greensboro",            state: "NC", lat: 36.07,  lng: -79.79  },
  { city: "Henderson",             state: "NC", lat: 36.33,  lng: -78.40  },
  // New Jersey
  { city: "Avenel",                state: "NJ", lat: 40.58,  lng: -74.27  },
  { city: "East Brunswick",        state: "NJ", lat: 40.43,  lng: -74.42  },
  { city: "Jersey City",           state: "NJ", lat: 40.72,  lng: -74.05  },
  // New York
  { city: "Albany",                state: "NY", lat: 42.65,  lng: -73.75  },
  { city: "Buffalo",               state: "NY", lat: 42.89,  lng: -78.88  },
  { city: "Chester",               state: "NY", lat: 41.36,  lng: -74.27  },
  { city: "Johnstown",             state: "NY", lat: 43.01,  lng: -74.37  },
  { city: "Little Falls",          state: "NY", lat: 43.04,  lng: -74.86  },
  { city: "Montgomery",            state: "NY", lat: 41.52,  lng: -74.24  },
  { city: "Syracuse",              state: "NY", lat: 43.05,  lng: -76.15  },
  // Ohio
  { city: "Cambridge",             state: "OH", lat: 40.03,  lng: -81.59  },
  { city: "Cincinnati",            state: "OH", lat: 39.10,  lng: -84.51  },
  { city: "Columbus",              state: "OH", lat: 39.96,  lng: -82.99  },
  { city: "Groveport",             state: "OH", lat: 39.86,  lng: -82.89  },
  { city: "Napoleon",              state: "OH", lat: 41.39,  lng: -84.13  },
  { city: "Tipp City",             state: "OH", lat: 39.96,  lng: -84.17  },
  { city: "Toledo",                state: "OH", lat: 41.66,  lng: -83.56  },
  { city: "Warrensville Heights",  state: "OH", lat: 41.44,  lng: -81.54  },
  // Oregon
  { city: "Portland",              state: "OR", lat: 45.52,  lng: -122.68 },
  { city: "Troutdale",             state: "OR", lat: 45.53,  lng: -122.38 },
  // Pennsylvania
  { city: "Bethel",                state: "PA", lat: 40.47,  lng: -76.29  },
  { city: "Bethlehem",             state: "PA", lat: 40.62,  lng: -75.37  },
  { city: "Carlisle",              state: "PA", lat: 40.20,  lng: -77.19  },
  { city: "Chambersburg",          state: "PA", lat: 39.94,  lng: -77.66  },
  { city: "Falls Creek",           state: "PA", lat: 41.14,  lng: -78.81  },
  { city: "Harrisburg",            state: "PA", lat: 40.27,  lng: -76.89  },
  { city: "Manns Choice",          state: "PA", lat: 39.99,  lng: -78.69  },
  { city: "McConnellsburg",        state: "PA", lat: 39.93,  lng: -77.99  },
  { city: "Pittsburgh",            state: "PA", lat: 40.44,  lng: -79.99  },
  { city: "Sayre",                 state: "PA", lat: 41.98,  lng: -76.52  },
  { city: "York",                  state: "PA", lat: 39.96,  lng: -76.73  },
  // South Carolina
  { city: "Eastover",              state: "SC", lat: 33.87,  lng: -80.69  },
  { city: "Taylors",               state: "SC", lat: 34.92,  lng: -82.29  },
  // South Dakota
  { city: "Huron",                 state: "SD", lat: 44.36,  lng: -98.21  },
  // Tennessee
  { city: "Lebanon",               state: "TN", lat: 36.21,  lng: -86.29  },
  { city: "Nashville",             state: "TN", lat: 36.17,  lng: -86.78  },
  // Texas
  { city: "Fort Worth",            state: "TX", lat: 32.75,  lng: -97.33  },
  { city: "Haslet",                state: "TX", lat: 32.97,  lng: -97.36  },
  { city: "Hutchins",              state: "TX", lat: 32.64,  lng: -96.71  },
  { city: "Paris",                 state: "TX", lat: 33.66,  lng: -95.56  },
  // Utah
  { city: "Brigham City",          state: "UT", lat: 41.51,  lng: -112.02 },
  { city: "Salt Lake City",        state: "UT", lat: 40.76,  lng: -111.89 },
  { city: "Tooele",                state: "UT", lat: 40.53,  lng: -112.30 },
  // Virginia
  { city: "Fredericksburg",        state: "VA", lat: 38.30,  lng: -77.46  },
  { city: "Roanoke",               state: "VA", lat: 37.27,  lng: -79.94  },
  { city: "Stuarts Draft",         state: "VA", lat: 38.01,  lng: -79.03  },
  // Washington
  { city: "Fife",                  state: "WA", lat: 47.24,  lng: -122.36 },
  { city: "Puyallup",              state: "WA", lat: 47.19,  lng: -122.29 },
  { city: "Ridgefield",            state: "WA", lat: 45.81,  lng: -122.74 },
  { city: "Tacoma",                state: "WA", lat: 47.25,  lng: -122.44 },
  { city: "Tukwila",               state: "WA", lat: 47.47,  lng: -122.26 },
  // Wisconsin
  { city: "Adams",                 state: "WI", lat: 43.96,  lng: -89.82  },
  { city: "DeForest",              state: "WI", lat: 43.24,  lng: -89.34  },
  { city: "Milwaukee",             state: "WI", lat: 43.04,  lng: -87.91  },
  { city: "Oak Creek",             state: "WI", lat: 42.88,  lng: -87.86  },
  { city: "Oconomowoc",            state: "WI", lat: 43.10,  lng: -88.50  },
  { city: "Racine",                state: "WI", lat: 42.73,  lng: -87.78  },
  { city: "Tomah",                 state: "WI", lat: 43.97,  lng: -90.50  },
  { city: "Wisconsin Dells",       state: "WI", lat: 43.62,  lng: -89.77  },
  // Wyoming
  { city: "Cheyenne",              state: "WY", lat: 41.14,  lng: -104.82 },
];

// Deduplicate by city+state key (same city listed from multiple carriers shows once on map)
const UNIQUE_POSITIONS = Array.from(
  new Map(ALL_POSITIONS.map((p) => [`${p.city}-${p.state}`, p])).values()
);

// Sorted list of all states that have positions
const STATE_OPTIONS = ["All States", ...Array.from(new Set(UNIQUE_POSITIONS.map((p) => p.state))).sort()];

export default function LocalPositionsMap() {
  const [activeState, setActiveState] = useState("All States");
  const [tooltip, setTooltip]         = useState(null);

  const filtered = activeState === "All States"
    ? UNIQUE_POSITIONS
    : UNIQUE_POSITIONS.filter((p) => p.state === activeState);

  const handleMarkerEnter = useCallback((e, pos) => {
    setTooltip({ ...pos, x: e.clientX, y: e.clientY });
  }, []);
  const handleMarkerLeave = useCallback(() => setTooltip(null), []);

  return (
    <section className="bg-[#0A0A0A] py-24 md:py-32" data-testid="local-positions-map">
      <div className="max-w-7xl mx-auto px-6 md:px-12">

        {/* Header */}
        <div className="mb-10">
          <span className="font-head text-xs md:text-sm font-bold uppercase tracking-[0.4em] text-primary">
            Local W2 Positions
          </span>
          <h2 className="font-head text-3xl md:text-5xl font-medium uppercase tracking-[0.15em] mt-4 text-white">
            Where We Hire Locally
          </h2>
          <p className="mt-4 text-white/60 max-w-2xl">
            Hylas Companion places CDL-A drivers in local W2 dedicated positions across the country — weekly pay, home-daily or home-weekly schedules. Select your state to see available markets.
          </p>
        </div>

        {/* State Dropdown */}
        <div className="flex flex-wrap items-center gap-4 mb-8">
          <label
            htmlFor="state-select"
            className="font-head text-xs uppercase tracking-[0.3em] text-white/40 shrink-0"
          >
            Filter by State
          </label>
          <div className="relative">
            <select
              id="state-select"
              data-testid="map-state-select"
              value={activeState}
              onChange={(e) => setActiveState(e.target.value)}
              className="appearance-none font-head text-xs uppercase tracking-[0.15em] bg-[#111] text-white border border-white/15 hover:border-white/40 focus:border-primary focus:outline-none px-4 py-2.5 pr-9 cursor-pointer transition-colors duration-150 min-w-[200px]"
            >
              {STATE_OPTIONS.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
            <ChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-white/40" />
          </div>
          {activeState !== "All States" && (
            <button
              onClick={() => setActiveState("All States")}
              className="font-head text-[10px] uppercase tracking-[0.2em] text-white/30 hover:text-white transition-colors"
            >
              Clear ×
            </button>
          )}
        </div>

        {/* Map */}
        <div className="relative border border-white/10 bg-[#0d0d0d] overflow-hidden">
          <ComposableMap
            projection="geoAlbersUsa"
            projectionConfig={{ scale: 1000 }}
            width={980}
            height={580}
            style={{ width: "100%", height: "auto" }}
          >
            <Geographies geography={GEO_URL}>
              {({ geographies }) =>
                geographies.map((geo) => {
                  const abbr = geo.properties.postal; // state abbreviation from atlas
                  const isActive = activeState === "All States" || geo.properties.name === activeState ||
                    UNIQUE_POSITIONS.some((p) => p.state === activeState);
                  return (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      style={{
                        default: { fill: "#1c1c1c", stroke: "#333", strokeWidth: 0.5, outline: "none" },
                        hover:   { fill: "#252525", stroke: "#444", strokeWidth: 0.5, outline: "none" },
                        pressed: { fill: "#1c1c1c", stroke: "#333", strokeWidth: 0.5, outline: "none" },
                      }}
                    />
                  );
                })
              }
            </Geographies>

            {filtered.map((pos, i) => (
              <Marker
                key={`${pos.city}-${pos.state}-${i}`}
                coordinates={[pos.lng, pos.lat]}
                onMouseEnter={(e) => handleMarkerEnter(e, pos)}
                onMouseLeave={handleMarkerLeave}
              >
                <circle
                  r={activeState === "All States" ? 4 : 5.5}
                  fill="#E8C547"
                  fillOpacity={0.85}
                  stroke="#0d0d0d"
                  strokeWidth={1}
                  style={{ cursor: "pointer" }}
                />
              </Marker>
            ))}
          </ComposableMap>

          {/* Stats overlay */}
          <div className="absolute top-3 right-3 bg-[#0A0A0A]/90 border border-white/10 px-4 py-2">
            <p className="font-head text-xs uppercase tracking-[0.2em] text-white/40">
              {activeState === "All States" ? "Total Positions" : activeState}
            </p>
            <p className="font-head text-2xl font-bold text-primary">{filtered.length}</p>
            <p className="font-head text-[10px] text-white/30 uppercase tracking-[0.15em]">markets</p>
          </div>
        </div>

        {/* City list for selected state */}
        <AnimatePresence>
          {activeState !== "All States" && (
            <motion.div
              key={activeState}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.25 }}
              className="mt-8 border border-white/10 p-6"
            >
              <p className="font-head text-sm uppercase tracking-[0.25em] text-white mb-5">
                Local W2 Positions in {activeState} — {filtered.length} {filtered.length === 1 ? "Market" : "Markets"}
              </p>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2">
                {filtered.map((pos, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-2 py-2 px-3 bg-white/[0.03] border border-white/[0.06]"
                  >
                    <MapPin className="w-3 h-3 shrink-0 text-primary/60" />
                    <span className="text-white/70 text-xs leading-tight">
                      {pos.city}
                    </span>
                  </div>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Apply CTA */}
        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <a
            href="/apply"
            data-testid="map-apply-btn"
            className="inline-flex items-center gap-2 font-head text-sm uppercase tracking-[0.2em] bg-primary text-black px-8 py-4 hover:bg-white transition-colors duration-300"
          >
            Apply for Local W2 <span aria-hidden>→</span>
          </a>
          <p className="text-white/40 text-sm">
            All positions · Weekly pay · Home daily or weekly
          </p>
        </div>
      </div>

      {/* Tooltip */}
      <AnimatePresence>
        {tooltip && (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.1 }}
            className="fixed z-[100] pointer-events-none"
            style={{ left: tooltip.x + 12, top: tooltip.y - 40 }}
          >
            <div className="bg-[#111] border border-white/20 px-3 py-2 shadow-xl">
              <p className="font-head text-xs font-bold text-white uppercase tracking-[0.1em]">
                {tooltip.city}, {tooltip.state}
              </p>
              <p className="text-[11px] text-white/50 mt-0.5">
                Local W2 Position · Weekly Pay
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
